var render = function render(){var _vm=this,_c=_vm._self._c;return _c('settings',_vm._b({attrs:{"setting-tabs":_vm.adminSettingTabs}},'settings',_vm.$props,false),[_c('team-icon',{staticClass:"team-icon",attrs:{"team":_vm.team}}),_vm._v("\n  "+_vm._s(_vm.team.name)+"\n  "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('roles'+'.'+_vm.role(_vm.team))))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }